import { InvitesPanel } from './InvitesPanel';
import { LegalPanel } from './LegalPanel';
import { SignupPanel } from './SignupPanel';
import { UsersPanel } from './UsersPanel';

export function AdminPage() {
  return (
    <section aria-labelledby="admin-title">
      <h1 id="admin-title">Admin</h1>
      <p className="muted">Invite friends and manage who can use Couch. Each person only ever sees their own machines.</p>
      <InvitesPanel />
      <UsersPanel />
      <SignupPanel />
      <LegalPanel />
    </section>
  );
}
